import { render } from "./TooltipLabel.vue?vue&type=template&id=2f2e7d68&scoped=true"
import script from "./TooltipLabel.vue?vue&type=script&lang=js"
export * from "./TooltipLabel.vue?vue&type=script&lang=js"

import "./TooltipLabel.vue?vue&type=style&index=0&id=2f2e7d68&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.2.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2e7d68"]])

export default __exports__